import BaseModel from '../core/BaseModel'
export default class GroupRoleModel extends BaseModel {

    constructor() {
        super({ 
                name: "group_role",
                tableName: 'group_role',
                label: "Phân công",
                display_key: 'name',
                default_order: { key: 'ordinal', direction: 'asc' } ,
            },
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Bigint",
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            group_id: {
                name: 'group_id',
                type: "Bigint",
                label: 'ID nhóm quyền',
                display: false
            },
            role_id: {
                name: 'role_id',
                type: "Bigint",
                label: 'ID quyền',
                display: false
            },
            active: {
                name: 'active',
                type: "Boolean",
                label: 'Kích hoạt',
                filter: {type: 'input', match: 'contains'},
                computed: (data) => {
                    data.active = true;
                }
            },
        },)
    }

}
